import { apiFetch } from './client';

export const getAssets    = ()           => apiFetch('/assets/');
export const getAsset     = (id)         => apiFetch(`/assets/${id}`);
export const createAsset  = (data)       => apiFetch('/assets/', { method: 'POST', body: JSON.stringify(data) });
export const updateAsset  = (id, data)   => apiFetch(`/assets/${id}`, { method: 'PUT', body: JSON.stringify(data) });
export const deleteAsset  = (id)         => apiFetch(`/assets/${id}`, { method: 'DELETE' });
